import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";
import { fontStringify } from "pdfmake/src/helpers.js";
export default class ReporteOcupacion {
  constructor() {}

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.data, mainData.totales);
    

    

    let imgColumn = {
      // star-sized columns fill the remaining space
      // if there's more than one star-column, available width is divided equally

      text: "",
      width: "10%",
    };
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "portrait",
      content: [
        //header
        {
          columns: [
            {
              // fixed width
              width: "100%",
              alignment: "center",
              bold: true,
              text: [mainData.TITLE + "\n"],
            },
          ],
        },
        {
          columns: [
            {
              // fixed width
              width: "35%",
              alignment: "left",
              bold: true,
              text: ["DEL " + mainData.FI + "\n", "A " + mainData.FF + "\n"],
            },
            {
              // fixed width
              width: "35%",
              alignment: "left",
              bold: true,
              text: [],
            },
            {
              // % width
              width: "30%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora Generado: " + mainData.HG + "\n",
              ],
            },
          ],
          // optional space between columns
          columnGap: 10,
        },
        {
          columns: [
            {
              // fixed width
              width: "100%",
              table: {
                widths: "*",
                heights: 25,
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data, totales) {
    
    let headers = [
      {
        text: "Hora",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
      {
        text: "Actual",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
      {
        text: "Potencial",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
      {
        text: "% Reservado",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
      {
        text: "% Disponible",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
    ];

    let times = [headers];

    data.forEach((time) => {
      let rowToAdd = [];

      rowToAdd = [
        {
          text: ["\n" + time.time + "-" + time.horaLimite + "\n"],
          fontSize: 12,
          alignment: "center",
        },
        {
          text: time.ocupado,
          fontSize: 12,
          alignment: "center",
        },
        {
          text: time.disponible,
          fontSize: 12,
          alignment: "center",
        },
        {
          text: pgsHelper.formatNumber(time.booked) + "%",
          fontSize: 12,
          alignment: "center",
        },
        {
          text: pgsHelper.formatNumber(time.unbooked) + "%",
          fontSize: 12,
          alignment: "center",
        },
      ];
      times.push(rowToAdd);
    });
    times.push([
      {
        text: "Totales",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
      {
        text: totales.totalActual,
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
      {
        text: totales.totalPotencial,
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
      {
        text: pgsHelper.formatNumber(totales.apartado) + '%',
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
      {
        text: pgsHelper.formatNumber(totales.noApartado) + '%',
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
    ]);

    /*if (data.adq) {
      data.adq.forEach((prod) => {
        let rowToAdd = [];

        rowToAdd = [
          {
            text: [prod.nom + "\n", "Rendimiento: " + prod.rdm + "\n"],
            border: [true, true, true, true],
            fontSize: 12,
          },
          {
            text: pgsHelper.formatNumber(prod.cnt),
            border: [true, true, true, true],
            fontSize: 12,
          },
          {
            text: pgsHelper.formatNumber(prod.pcu.C) + " " + prod.pcu.M,
            border: [true, true, true, true],
            fontSize: 12,
          },
        ];
        times.push(rowToAdd);
      });
    }
    times.push([
      {
        text: "",
        border: [true, true, true, true],
        fontSize: 8,
      },
      { text: "", border: [true, true, true, true], fontSize: 8 },
      {
        text: "Total: " + data.Total,
        border: [true, true, true, true],
        fontSize: 14,
      },
    ]);*/
    return times;
  }

  static getFirmas(data, porcentaje) {
    let times = [
      [
        { text: "Mesero", border: [true, true, true, true], fontSize: 12 },
        { text: "Total", border: [true, true, true, true], fontSize: 12 },
        {
          text: "%" + porcentaje,
          border: [true, true, true, true],
          fontSize: 12,
        },
        { text: "Firma", border: [true, true, true, true], fontSize: 12 },
      ],
    ];
    data.forEach((venta) => {
      let rowToAdd = [];
      if (venta.tipo == "footer") {
        rowToAdd = [
          {
            text: venta.Mesero,
            border: [true, true, true, true],
            fontSize: 10,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Total),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text:
              "$" +
              pgsHelper.formatNumber((venta.Total * Number(porcentaje)) / 100),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text: " ",
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "center",
          },
        ];
        times.push(rowToAdd);
      }
    });

    let table = {
      border: [true, false, true, true],
      widths: ["*"],
      heights: 60,
      table: {
        body: times,
      },
    };

    return times;
  }
}
